module.exports = __webpack_public_path__ + "img/silverware_variant_icon_137189.svg";